


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import EditModal from './EditModal';
// import { MdDeleteForever } from 'react-icons/md';
// import { MdModeEditOutline } from 'react-icons/md';
// import { FaEye } from 'react-icons/fa';
// import { PiDownloadSimple } from 'react-icons/pi';
// import { downloadedImageCount, updateStatus } from '../api/api';
// import { toast } from 'react-toastify';


// const Card = ({ image, categories, onSave, onDelete, image_id }) => {
//   console.log(image,categories,onSave,onDelete,image_id)
//   const [isModalVisible, setModalVisible] = useState(false);
//   const [isFullscreenVisible, setFullscreenVisible] = useState(false);
//   const [downloadCount, setDownloadCount] = useState(0);
//   const [status, setStatus] = useState(image.status); // initialize with image status
// console.log(status,"==status")
//   useEffect(() => {
//     const fetchDownloadCount = async () => {
//       try {
//         const response = await axios.post(downloadedImageCount, { image_id });
//         if (response.data.result.length > 0) {
//           setDownloadCount(response.data.result[0].COUNT || 0);
//         } else {
//           setDownloadCount(0);
//         }
//       } catch (error) {
//         console.error('Error fetching download count:', error);
//         setDownloadCount(0);
//       }
//     };

//     fetchDownloadCount();
//   }, [image_id]);

//   const handleEditClick = () => {
//     setModalVisible(true);
//   };

//   const handleSave = (updatedImage) => {
//     onSave(updatedImage);
//     setModalVisible(false);
//   };

//   const handleImageClick = () => {
//     setFullscreenVisible(true);
//   };

//   const handleFullscreenClose = () => {
//     setFullscreenVisible(false);
//   };

//   const handleView = () => {
//     setFullscreenVisible(true);
//   };

//   const handleStatusToggle = async () => {
//     const newStatus = status === 1 ? 0 : 1;
//     console.log(newStatus,"==newstATUS")
//     try {
//       await axios.post(updateStatus, {
//         status: newStatus,
//         id: image_id
//       });
//       setStatus(newStatus); // update local state
//        // Show toast
//     if (newStatus === 0) {
//       toast.success(`Enabled image: ${image.name}`);
//     } else {
//       toast.error(`Disabled image: ${image.name}`);
//     }
//     } catch (err) {
//       console.error("Failed to update status", err);
//     }
//   };

//   return (
//     <div className="relative group mt-4 rounded-lg shadow-lg bg-white/35 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto">
//       <img
//         src={image.url}
//         alt={image.name}
//         className="rounded-lg md:w-[400px] md:h-[300px] lg:w-[300px] lg:h-[300px] w-[300px] h-[200px] cursor-pointer"
//         onClick={handleImageClick}
//       />
//       <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-center items-center">
//         <h2 className="text-lg font-semibold text-white mb-2">{image.name}</h2>
//         <p className="text-white mb-4">Category: {image.category}</p>
//         <div className="flex space-x-4">
//           <button
//             onClick={handleView}
//             className="flex items-center justify-center p-2 bg-blue-500 text-white rounded-3xl"
//           >
//             <FaEye size={20} color="white" />
//           </button>
//           <button
//             onClick={handleEditClick}
//             className="flex items-center justify-center p-2 bg-green-500 text-white rounded-3xl"
//           >
//             <MdModeEditOutline size={20} color="white" />
//           </button>
//           <button
//             onClick={() => onDelete(image.id)}
//             className="flex items-center justify-center p-2 bg-red-500 text-white rounded-3xl"
//           >
//             <MdDeleteForever size={20} color="white" />
//           </button>
//         </div>

//         {/* Enable/Disable Toggle Button */}
//         <button
//           onClick={handleStatusToggle}
//           className={`px-8 py-2 mt-8 text-white font-bold rounded-full transition-transform transform-gpu hover:-translate-y-1 hover:shadow-lg ${
//             status === 1
//               ? 'bg-red-600 hover:bg-red-700'
//               : 'bg-green-600 hover:bg-green-700'
//           }`}
//         >
//           {status === 1 ? 'Enable' : 'Disable'}
//         </button>
//       </div>

//       {/* Download count bubble */}
//       <div className="absolute bottom-1 right-1 p-1 bg-black/70 text-white rounded-full z-10 flex items-center justify-center">
//         <PiDownloadSimple size={20} color="white" />
//         <span className="absolute -top-2 -right-1 text-white text-xs rounded-full px-2 py-1">
//           {downloadCount}
//         </span>
//       </div>

//       {/* Edit Modal */}
//       <EditModal
//         visible={isModalVisible}
//         onHide={() => setModalVisible(false)}
//         image={image}
//         categories={categories}
//         onSave={handleSave}
//       />

//       {/* Fullscreen view */}
//       {isFullscreenVisible && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
//           <div className="relative">
//             <img
//               src={image.url}
//               alt={image.name}
//               className="max-w-full max-h-screen object-contain"
//             />
//             <button
//               onClick={handleFullscreenClose}
//               className="absolute top-4 right-4 text-white text-3xl bg-black bg-opacity-50 rounded-full p-2"
//             >
//               &times;
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Card;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EditModal from './EditModal';
import { MdDeleteForever, MdModeEditOutline } from 'react-icons/md';
import { FaEye } from 'react-icons/fa';
import { PiDownloadSimple } from 'react-icons/pi';
import { downloadedImageCount, updateStatus } from '../api/api';
import { toast } from 'react-toastify';

const Card = ({ image, categories, onSave, onDelete, image_id }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [isFullscreenVisible, setFullscreenVisible] = useState(false);
  const [downloadCount, setDownloadCount] = useState(0);
  const [status, setStatus] = useState(image.status);

  const isVideo = (url) => {
    if (!url) return false;
    return /\.(mp4|webm|ogg)$/i.test(url);
  };

  useEffect(() => {
    const fetchDownloadCount = async () => {
      try {
        const response = await axios.post(downloadedImageCount, { image_id });
        const count = response.data?.result?.[0]?.COUNT || 0;
        setDownloadCount(count);
      } catch (error) {
        console.error('Error fetching download count:', error);
      }
    };
    fetchDownloadCount();
  }, [image_id]);

  const handleEditClick = () => setModalVisible(true);
  const handleSave = (updatedImage) => {
    onSave(updatedImage);
    setModalVisible(false);
  };

  const handleStatusToggle = async () => {
    const newStatus = status === 1 ? 0 : 1;
    try {
      await axios.post(updateStatus, { status: newStatus, id: image_id });
      setStatus(newStatus);
      toast.success(`${newStatus === 0 ? 'Enabled' : 'Disabled'}: ${image.name}`);
    } catch (err) {
      console.error("Failed to update status", err);
    }
  };

  return (
    <div className="relative group mt-4 rounded-lg shadow-lg bg-white/35 max-w-xs mx-auto">
      {/* Media Preview */}
      {image.url && (
        isVideo(image.url) ? (
          <video
            src={image.url}
            controls
            className="rounded-lg w-[300px] h-[200px] cursor-pointer"
            onClick={() => setFullscreenVisible(true)}
          />
        ) : (
          <img
            src={image.url}
            alt={image.name}
            className="rounded-lg w-[300px] h-[200px] object-cover cursor-pointer"
            onClick={() => setFullscreenVisible(true)}
          />
        )
      )}

      {/* Hover Overlay */}
      <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col justify-center items-center">
        <h2 className="text-lg font-semibold text-white mb-2">{image.name}</h2>
        <p className="text-white mb-4">Category: {image.category}</p>
        <div className="flex space-x-4">
          <button onClick={() => setFullscreenVisible(true)} className="p-2 bg-blue-500 text-white rounded-full">
            <FaEye size={20} />
          </button>
          <button onClick={handleEditClick} className="p-2 bg-green-500 text-white rounded-full">
            <MdModeEditOutline size={20} />
          </button>
          <button onClick={() => onDelete(image.id)} className="p-2 bg-red-500 text-white rounded-full">
            <MdDeleteForever size={20} />
          </button>
        </div>
        <button
          onClick={handleStatusToggle}
          className={`px-6 py-2 mt-4 rounded-full font-bold text-white ${status == 0? 'bg-green-600' : 'bg-red-600'}`}
        >
          {status == 0 ? 'Enable' : 'Disable'}
        </button>
      </div>

      {/* Download Count */}
      <div className="absolute bottom-1 right-1 flex items-center p-1 bg-black/70 text-white rounded-full">
        <PiDownloadSimple size={20} />
        <span className="ml-1 text-sm">{downloadCount}</span>
      </div>

      {/* Edit Modal */}
      <EditModal
        visible={isModalVisible}
        onHide={() => setModalVisible(false)}
        image={image}
        categories={categories}
        onSave={handleSave}
      />

      {/* Fullscreen View */}
      {isFullscreenVisible && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
          <div className="relative">
            {isVideo(image.url) ? (
              <video src={image.url} controls autoPlay className="max-w-full max-h-screen" />
            ) : (
              <img src={image.url} alt={image.name} className="max-w-full max-h-screen" />
            )}
            <button
              onClick={() => setFullscreenVisible(false)}
              className="absolute top-2 right-2 text-white text-3xl font-bold"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
